import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import { setNavCommunity } from "Actions";
import { changeNavCommunity } from "Thunks";

import {
  getCommunityDisplayName,
  getCommunityRoute,
  getCommunityLogoUrl
} from "Utils";

import { selectUserCommunities, selectNavCommunity } from "Selectors";

export class Communities extends Component {
  static propTypes = {
    setNavCommunity: PropTypes.func
  };

  handleSelectCommunity = community => {
    const { setNavCommunity, changeNavCommunity } = this.props;
    setNavCommunity(community);
    changeNavCommunity(community.id);
    setTimeout(() => {
      window.location.reload(true);
    }, 200);
  };

  renderCommunities() {
    const { communities, navCommunity } = this.props;

    if (!communities || communities.length === 0) {
      return null;
    }

    const communitiesBlock = communities.map(community => {
      if (navCommunity && navCommunity.id === community.id) {
        return null;
      }

      return (
        <li className="menu__sub-child" key={`community-${community.id}`}>
          <NavLink
            exact
            id={"btnCom" + community.id}
            to={`${getCommunityRoute(community)}`}
            activeClassName="active"
            onClick={this.handleSelectCommunity.bind(this, community)}
          >
            <span
              className="boxes__box__logo"
              style={{
                backgroundImage: `url(${getCommunityLogoUrl(community)})`
              }}
            />
            {getCommunityDisplayName(community)}
          </NavLink>
        </li>
      );
    });

    return (
      <div className="menu__dropdown">
        <ul>{communitiesBlock}</ul>
      </div>
    );
  }

  render() {
    const { communities, navCommunity } = this.props;

    if (!communities || communities.length <= 1) {
      return null;
    }

    return (
      <li className="menu__has-child menu__community">
        <NavLink
          exact
          to={getCommunityRoute(navCommunity)}
          activeClassName="active"
          className="menu__link"
        >
          {navCommunity ? getCommunityDisplayName(navCommunity) : null}
          <i className="icon icon-arrow-down" />
        </NavLink>
        {this.renderCommunities()}
      </li>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  routing: state.routing,
  communities: selectUserCommunities(state),
  navCommunity: selectNavCommunity(state)
});

const mapDispatchToProps = dispatch => ({
  setNavCommunity: community => dispatch(setNavCommunity(community)),
  changeNavCommunity: communityId => dispatch(changeNavCommunity(communityId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Communities);



// WEBPACK FOOTER //
// ./src/components/Menu/Communities.js